import { TICKET_TYPES } from "@app/utils/constants"
import { getTimeString } from "@app/utils/localeUtils"

export default function getTbInfo(tbKind) {
	let timeblock = null
	let timeslot = null

	let d = new Date()
	d.setSeconds(0)
	d.setMinutes(d.getMinutes() + 15) //apply treshold time
	const currentTime = d.toTimeString().split(" ")[0]
	const currentTimeInMinutes = Number(currentTime.split(":")[0]) * 60 + Number(currentTime.split(":")[1])

	//If the tbKind block is a wholeday Ticket we can directly select the first entry
	if (tbKind.timeBlocks[0].timeBlockTypeId === TICKET_TYPES.WholeDay) {
		timeblock = tbKind.timeBlocks[0]
		timeslot = timeblock.timeSlots[0]

		if (timeblock.restCount <= 0 || timeblock.timeSlots.length < 1) {
			timeblock = null
			timeslot = null
		}

		return {
			timeblock,
			timeslot,
		}
	}

	/**
	 * We ranking the timeslots by the distance to the current timeslots. But when we have a timeblock change (day to evening) timeslots must have a distance > 0
	 * otherwhise the timeslots will be ignored. So that we must be always higher than the timeslot. IF we wouldn't do that the alg would rank the evening timeslot
	 * higher than the last timeslot of the day capacity when we a nearer to the evening discount and we want to prevent that.
	 */
	let ranking = []
	const diffBetweenSlots = getDiffBetweenSlots(tbKind)
	let lastTb = null
	for (let i = 0; i < tbKind.timeBlocks.length; i++) {
		const tb = tbKind.timeBlocks[i]
		const isDifferentBlock = !!lastTb || (lastTb !== null && lastTb.timeBlockKindId !== tb.timeblockKindId)
		lastTb = tb

		//we ignore tb's with no restCount
		if (tb.restCount <= 0 || tb.timeSlots.length < 1) {
			continue
		}

		for (let ts of tb.timeSlots) {
			const tsFromInMinutes = Number(ts.timeFrom.split(":")[0]) * 60 + Number(ts.timeFrom.split(":")[1])
			const tsToInMinutes = Number(ts.timeTo.split(":")[0]) * 60 + Number(ts.timeTo.split(":")[1])
			const diffByNearestTime = currentTimeInMinutes - tsFromInMinutes

			//We ignore timeslots that are before the timeFrom if we changed the timeblock in the last loop. See comment above to know why.
			if (isDifferentBlock && diffByNearestTime < 0) {
				continue
			}
			//igtnore slots where the timeTo is in the past
			if (tsToInMinutes <= currentTimeInMinutes) {
				continue
			}

			//Calculate a weight for the distance. The further the distance is near the 0 the higher the weight (1 highest, 0 lowest)
			//0 means the distance is exatcly high as the difference between the ighest timeTo - timeFrom so theoreticly it could drop below 0
			const weight = (Math.abs(diffByNearestTime) - diffBetweenSlots) / (0 - diffBetweenSlots)
			ranking.push({
				timeblock: tb,
				timeslot: ts,
				weight,
			})
		}
	}

	ranking.sort((a, b) => {
		//the next is the valid one if we have the same weight. So we go always into the future
		if (a.weight === b.weight) {
			return -1
		}
		return b.weight - a.weight
	})
	let result = ranking[0]
	if (result) {
		timeblock = result.timeblock
		timeslot = result.timeslot
	}

	return {
		timeblock,
		timeslot,
		nextTime: getNextTime(currentTime, tbKind),
	}
}

function getNextTime(currentTime, tbKind) {
	let nextTime = undefined
	for (let i = 0; i < tbKind.timeBlocks.length; i++) {
		let e = tbKind.timeBlocks[i]

		if (e.restCount <= 0 || e.timeSlots.length < 1) {
			continue
		}

		for (let j = 0; j < e.timeSlots.length; j++) {
			let t = e.timeSlots[j]
			if (t.timeFrom >= currentTime) {
				nextTime = t
				break
			}
		}

		if (nextTime) {
			let ts = nextTime.timeFrom.split(":")
			let date = new Date()
			date.setHours(Number(ts[0]))
			date.setMinutes(Number(ts[1]))

			nextTime = getTimeString(date)
			break
		}
	}
	return nextTime
}

/**
 * Calculates the highest difference between timeslots from (timeTo - timeFrom)
 * @param {} tbKind
 * @returns
 */
function getDiffBetweenSlots(tbKind) {
	let current = 0
	for (let timeblock of tbKind.timeBlocks) {
		let first = timeblock.timeSlots[0]?.timeFrom
		let second = timeblock.timeSlots[1]?.timeTo
		if (first && second) {
			let fh = Number(first.split(":")[0]) * 60
			let sh = Number(second.split(":")[0]) * 60
			let diff = Math.abs(fh - sh)
			if (diff > current) {
				current = diff
			}
		}
	}

	return current
}
